import {
  getRLType,
  transformedInlineRLFields,
} from "../../../utils/helpers/relatedListHelpers";

export function getPickListValues(
  fieldName: string,
  formValues: any,
  options: any[],
  rlParentFieldName: string | undefined,
  allPickListOptions: any,
  rlPickListOptions: any
) {
  // compare with fetched value and return only available options
  const inlineRLFieldNames = Object.values(transformedInlineRLFields)
    .flat()
    .map((list: any) => Object.keys(list))
    .flat();
  if (!(fieldName in formValues) && rlParentFieldName) {
    const rlType = getRLType(rlParentFieldName);
    const regex = /(\w+)(?:\[\d+\])?\.(\w+)/;
    const match = fieldName.match(regex);
    const _fieldName = match ? match[2] : "";
    const fetchedPicklistValues = rlType
      ? rlPickListOptions?.[rlType]?.[_fieldName]
      : [];
    return !fetchedPicklistValues
      ? []
      : fetchedPicklistValues.filter((pickListValue: string) =>
          options.includes(pickListValue)
        );
  }

  if (inlineRLFieldNames.includes(fieldName)) {
    const rlType = Object.keys(transformedInlineRLFields).filter((key) =>
      Object.keys(transformedInlineRLFields[key]).includes(fieldName)
    );
    const fetchedPicklistValues = rlType.length
      ? rlPickListOptions?.[rlType[0]]?.[fieldName]
      : [];
    return fetchedPicklistValues ?? [];
  }

  if (fieldName === "Pulse__c") {
    return options || [];
  }

  return allPickListOptions[fieldName] || [];
}
